import React from 'react';
import { SpinningLoader, Tabs } from '@weave/design-system';
import { css } from '@emotion/core';

export type UnifyEvalTab = 'needs-attention' | 'processing' | 'completed';

export interface UnifyMetricsTabsProps {
  activeTab: UnifyEvalTab;
  onChange: (tab: UnifyEvalTab) => void;
  needsAttentionCount: number;
  processingCount: number;
}

export const UnifyMetricsTabs: React.FC<UnifyMetricsTabsProps> = ({
  activeTab,
  onChange,
  needsAttentionCount,
  processingCount,
}) => {
  return (
    <Tabs
      initialTab={activeTab}
      controlledTab={activeTab}
      onChange={(tab) => onChange(tab as UnifyEvalTab)}
    >
      <Tabs.Bar>
        {needsAttentionCount > 0 && (
          <Tabs.Tab
            id="needs-attention"
            controls="needs-attention-panel"
            css={styles.tab}
          >
            <span css={styles.tabLabel}>
              Needs Attention
              <span
                css={styles.badge}
                aria-label={`${needsAttentionCount} items needing attention`}
              >
                {needsAttentionCount}
              </span>
            </span>
          </Tabs.Tab>
        )}
        {processingCount > 0 && (
          <Tabs.Tab id="processing" controls="processing-panel" css={styles.tab}>
            <span css={styles.tabLabel}>
              Processing
              <SpinningLoader size="small" />
            </span>
          </Tabs.Tab>
        )}
        <Tabs.Tab id="completed" controls="completed-panel" css={styles.tab}>
          Completed
        </Tabs.Tab>
      </Tabs.Bar>
    </Tabs>
  );
};

const styles = {
  tab: css`
    flex: 1;
  `,
  tabLabel: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,
  badge: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background-color: #d9363e;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
  `,
};
